import * as i0 from '@angular/core';
import { Injectable, Component, Inject, NgModule } from '@angular/core';
import { CoreServicesModule } from '@tangilla/tg-ng-core/src/lib/core-services';
import { saveAs } from 'file-saver';
import * as i1$1 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2 from '@angular/material/button';
import { MatButtonModule } from '@angular/material/button';
import moment from 'moment-timezone';
import jwt_decode from 'jwt-decode';

class ReportingUtilsService {
    formatReportMeta(reportBody) {
        const formattedValues = [];
        let paramCounter = 1;
        for (const key of Object.keys(reportBody)) {
            const formattedValue = {
                param_id: paramCounter,
                values: reportBody[key] || reportBody[key] === 0 ? reportBody[key] : null,
                name: key
            };
            formattedValues.push(formattedValue);
            paramCounter++;
        }
        return formattedValues;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReportingUtilsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReportingUtilsService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: ReportingUtilsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }] });

class SnackbarComponent {
    constructor(data) {
        this.data = data;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SnackbarComponent, deps: [{ token: MAT_SNACK_BAR_DATA }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "16.2.12", type: SnackbarComponent, selector: "tg-snackbar", ngImport: i0, template: "<div class=\"snackbar-container\" style=\"{{data.longTextButton && 'flex-wrap: wrap; justify-content: flex-end'}}\">\n  <div class=\"snackbar-text\" [innerHTML]=\"data.message\"></div>\n  <button *ngIf=\"data.buttonText && data.buttonAction\"\n    mat-button color=\"primary\"\n    (click)=\"data.buttonAction()\"\n    class=\"snackbar-action-button\"\n    >\n    <span class=\"snackbar-button-text\">{{data.buttonText}}\n    </span>\n  </button>\n</div>\n\n", styles: [".snackbar-text{line-height:20px}.snackbar-container{display:flex;align-items:center;justify-content:space-between}.snackbar-action-button{padding-right:0}.snackbar-button-text{font-weight:500;letter-spacing:1px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: i2.MatButton, selector: "    button[mat-button], button[mat-raised-button], button[mat-flat-button],    button[mat-stroked-button]  ", inputs: ["disabled", "disableRipple", "color"], exportAs: ["matButton"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SnackbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'tg-snackbar', template: "<div class=\"snackbar-container\" style=\"{{data.longTextButton && 'flex-wrap: wrap; justify-content: flex-end'}}\">\n  <div class=\"snackbar-text\" [innerHTML]=\"data.message\"></div>\n  <button *ngIf=\"data.buttonText && data.buttonAction\"\n    mat-button color=\"primary\"\n    (click)=\"data.buttonAction()\"\n    class=\"snackbar-action-button\"\n    >\n    <span class=\"snackbar-button-text\">{{data.buttonText}}\n    </span>\n  </button>\n</div>\n\n", styles: [".snackbar-text{line-height:20px}.snackbar-container{display:flex;align-items:center;justify-content:space-between}.snackbar-action-button{padding-right:0}.snackbar-button-text{font-weight:500;letter-spacing:1px}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_SNACK_BAR_DATA]
                }] }]; } });

class SnackbarService {
    constructor(matSnackbar) {
        this.matSnackbar = matSnackbar;
    }
    message(message, buttonText, buttonAction, longTextButton) {
        this.openSnackbar(message, undefined, buttonText, buttonAction, longTextButton);
    }
    success(message) {
        this.openSnackbar(message, 'snackbar-success');
    }
    error(message) {
        this.openSnackbar(message, 'snackbar-error');
    }
    exception(exception, message) {
        if (exception.error && exception.error.error && exception.error.error.status === 409) {
            this.error(message ? message : exception.error.error.message);
        }
        else {
            this.error(message ? message : exception.userMessage);
        }
    }
    warning(message) {
        this.openSnackbar(message, 'snackbar-warning');
    }
    openSnackbar(message, colorClass, buttonText, buttonAction, longTextButton) {
        this.matSnackbar.openFromComponent(SnackbarComponent, {
            data: {
                message,
                buttonText,
                buttonAction,
                longTextButton
            },
            panelClass: colorClass,
            horizontalPosition: 'right',
            // duration: 60000
        });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SnackbarService, deps: [{ token: i1$1.MatSnackBar }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SnackbarService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SnackbarService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatSnackBar }]; } });

class FilesUtilsService {
    constructor(snackbarService) {
        this.snackbarService = snackbarService;
    }
    openBlob(blob, target = '_blank', filename) {
        if (filename) {
            const fileURL = URL.createObjectURL(blob);
            this.forceDownload(fileURL, filename);
            return;
        }
        // Edge/IE navigators need to open it like this
        // @ts-ignore
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            // @ts-ignore
            const msWindowOpened = window.navigator.msSaveOrOpenBlob(blob);
            if (!msWindowOpened) {
                this.showPopupWarning();
            }
            return msWindowOpened;
        }
        const fileURL = URL.createObjectURL(blob);
        const newWin = window.open(fileURL, target);
        const isWindowOpen = newWin && !newWin.closed && typeof newWin.closed !== 'undefined';
        if (!isWindowOpen) {
            this.showPopupWarning();
        }
        return isWindowOpen;
    }
    forceDownload(blob, filename) {
        var a = document.createElement('a');
        a.download = filename;
        // @ts-ignore
        a.href = blob;
        // For Firefox https://stackoverflow.com/a/32226068
        document.body.appendChild(a);
        a.click();
        a.remove();
    }
    showPopupWarning() {
        this.snackbarService.warning('A pop-up blocker didn\'t allow us to open the file');
    }
    writeToCSVFile(data, fileName, join = ',') {
        const replacer = (key, value) => value === null ? '' : value;
        const header = Object.keys(data[0]);
        const csv = data.map((row) => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(join));
        csv.unshift(header.join(join));
        let csvArray = csv.join('\r\n');
        const blob = new Blob([csvArray], { type: 'text/csv' });
        saveAs(blob, fileName); //fileNameExample: "myFile.csv"
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FilesUtilsService, deps: [{ token: SnackbarService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FilesUtilsService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: FilesUtilsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return [{ type: SnackbarService }]; } });

class SnackbarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SnackbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "16.2.12", ngImport: i0, type: SnackbarModule, declarations: [SnackbarComponent], imports: [CommonModule,
            MatSnackBarModule,
            MatButtonModule], exports: [SnackbarComponent] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SnackbarModule, imports: [CommonModule,
            MatSnackBarModule,
            MatButtonModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: SnackbarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        SnackbarComponent
                    ],
                    imports: [
                        CommonModule,
                        MatSnackBarModule,
                        MatButtonModule
                    ],
                    exports: [
                        SnackbarComponent
                    ]
                }]
        }] });

class LayoutUtilService {
    getExceptionMessage(exception) {
        if (exception.error && exception.error.error && exception.error.error.status === 409) {
            return exception.error.error.message;
        }
        else {
            return exception.userMessage || exception.result_message;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LayoutUtilService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LayoutUtilService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LayoutUtilService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }] });

class LicensesUtilService {
    validateStateLicense(stateLicenseNumber, stateAbbreviation) {
        switch (stateAbbreviation) {
            case 'OH':
                const stateLicensePattern = new RegExp('^[a-zA-Z0-9]+\\.[0-9]{10}$');
                const isValid = stateLicensePattern.test(stateLicenseNumber);
                if (!isValid) {
                    return {
                        invalidWithMessage: true,
                        errorMessage: 'Must start with non special characters, contain a dot (".") and 10 numbers after it.'
                    };
                }
                break;
            case 'TX':
                if (!stateLicenseNumber || stateLicenseNumber.length > 7) {
                    return { invalidWithMessage: true, errorMessage: 'TX state licenses must have 7 numbers or less.' };
                }
                break;
            case 'IA':
            case 'AZ':
            default:
                break;
        }
        return null;
    }
    transformStateToNRDSLicense(stateLicenseNumber, stateAbbreviation) {
        let nrdsLicenseNumber = stateLicenseNumber;
        if (nrdsLicenseNumber) {
            switch (stateAbbreviation) {
                case 'OH':
                    if (nrdsLicenseNumber.includes('.')) {
                        const splitStateLicenseNumber = stateLicenseNumber.split('.');
                        nrdsLicenseNumber = splitStateLicenseNumber[1];
                    }
                    break;
                case 'TX':
                    nrdsLicenseNumber = stateLicenseNumber.padStart(7, '0');
                    break;
                case 'IA':
                case 'AZ':
                case 'LA':
                    nrdsLicenseNumber = stateLicenseNumber.replace(/\D/g, '').padStart(9, '0');
                    break;
                default:
                    break;
            }
        }
        return nrdsLicenseNumber;
    }
    getStateLicenseNumberMaxLength(stateAbbreviation) {
        const stateLicenseProperties = {
            maxLength: 255,
            relatedLicenseMaxLength: 255,
            affiliatedLicenseMaxLength: 255,
        };
        switch (stateAbbreviation) {
            case 'TX':
                stateLicenseProperties.maxLength = 7;
                stateLicenseProperties.relatedLicenseMaxLength = 7;
                stateLicenseProperties.affiliatedLicenseMaxLength = 7;
                break;
            case 'OH':
                stateLicenseProperties.relatedLicenseMaxLength = 10;
                stateLicenseProperties.affiliatedLicenseMaxLength = 10;
                break;
            case 'IA':
            case 'AZ':
            default:
                break;
        }
        return stateLicenseProperties;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LicensesUtilService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LicensesUtilService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: LicensesUtilService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }] });

class BillingEntitiesUtilService {
    constructor() {
    }
    getBillingYearOptions() {
        return [
            { value: moment().subtract(1, 'year').year(), label: moment().subtract(1, 'year').year() },
            { value: moment().year(), label: moment().year() },
            { value: moment().add(1, 'year').year(), label: moment().add(1, 'year').year() },
        ];
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingEntitiesUtilService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingEntitiesUtilService, providedIn: CoreServicesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: BillingEntitiesUtilService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: CoreServicesModule
                }]
        }], ctorParameters: function () { return []; } });

class RouteUtilsService {
    getCurrentUrlQueryParams() {
        let params = {};
        const urlSearchParams = new URLSearchParams(window.location.search);
        urlSearchParams.forEach((value, key) => {
            params[key] = value;
        });
        return params;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RouteUtilsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RouteUtilsService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "16.2.12", ngImport: i0, type: RouteUtilsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

function DeleteModal(modalProps) {
    return (target, name, descriptor) => {
        const method = descriptor.value; // references the method being decorated
        descriptor.value = function (...args) {
            return this.componentModalService.openConfirmModal({
                data: {
                    title: `Delete This ${modalProps.title}`,
                    description: `<p>Permanently delete this ${modalProps.row}?<br />You cannot undo this.</p>${modalProps.extraText && (!modalProps.extraTextConditionMethodName || this[modalProps.extraTextConditionMethodName]()) ? `<p>${modalProps.extraText}</p>` : ''}`,
                    confirmButtonLabel: 'Delete',
                    cancelButtonLabel: 'Cancel',
                    icon: modalProps.icon,
                    iconClass: modalProps.iconClass
                }
            }).afterClosed().subscribe({
                next: (ok) => {
                    if (ok) {
                        method.apply(this, args);
                    }
                }
            });
        };
    };
}
function CustomModal(modalProps) {
    return (target, name, descriptor) => {
        const method = descriptor.value; // references the method being decorated
        descriptor.value = function (...args) {
            if ((!modalProps.conditionPropertyName || this[modalProps.conditionPropertyName]) && (!modalProps.conditionMethodName || this[modalProps.conditionMethodName]())) {
                return this.componentModalService.openConfirmModal({
                    data: {
                        title: `${modalProps.title}`,
                        description: `<p>${modalProps.message}</p>`,
                        confirmButtonLabel: modalProps.confirmButtonLabel || 'Confirm',
                        cancelButtonLabel: modalProps.cancelButtonLabel || 'Cancel',
                        icon: modalProps.icon,
                        iconClass: modalProps.iconClass
                    }
                }).afterClosed().subscribe({
                    next: (ok) => {
                        if (ok) {
                            method.apply(this, args);
                        }
                    }
                });
            }
            else {
                return method.apply(this, args);
            }
        };
    };
}

var RouterMap;
(function (RouterMap) {
    function getProjectFirstPage(firstPage) {
        return firstPage ? firstPage : Home.ROOT;
    }
    RouterMap.getProjectFirstPage = getProjectFirstPage;
    function rootUrl(routes) {
        return '/' + routes.join('/');
    }
    RouterMap.rootUrl = rootUrl;
    let Home;
    (function (Home) {
        Home.ROOT = 'home';
        function url(routes) {
            return '/' + Home.ROOT + '/' + routes.join('/');
        }
        Home.url = url;
    })(Home = RouterMap.Home || (RouterMap.Home = {}));
    let Unauthorized;
    (function (Unauthorized) {
        Unauthorized.ROOT = 'unauthorized';
        function url(routes) {
            return '/' + Unauthorized.ROOT + '/' + routes.join('/');
        }
        Unauthorized.url = url;
    })(Unauthorized = RouterMap.Unauthorized || (RouterMap.Unauthorized = {}));
    let Auth;
    (function (Auth) {
        Auth.ROOT = '', Auth.LOGIN = 'login', Auth.LOGOUT = 'logout', Auth.ERROR = 'error', Auth.LOGIN_USER_SELECTOR = 'login-user-selector', Auth.MAINTENANCE = 'maintenance';
        function url(routes) {
            return '/' + Auth.ROOT + '/' + routes.join('/');
        }
        Auth.url = url;
    })(Auth = RouterMap.Auth || (RouterMap.Auth = {}));
    let MyAssociation;
    (function (MyAssociation) {
        MyAssociation.ROOT = '', MyAssociation.PROFILE = 'profile', MyAssociation.EDIT_PROFILE = 'profile/edit', MyAssociation.NOTIFICATIONS = 'notifications', MyAssociation.COURSES_AND_EVENTS = 'courses-and-events', MyAssociation.COMMITTEES = 'committees', MyAssociation.CONTRIBUTIONS = 'contributions', MyAssociation.EMAIL_PREFERENCES = 'email-preferences', MyAssociation.FORMS = 'forms';
        function url(routes) {
            return '/' + MyAssociation.ROOT + '/' + routes.join('/');
        }
        MyAssociation.url = url;
    })(MyAssociation = RouterMap.MyAssociation || (RouterMap.MyAssociation = {}));
    let Billing;
    (function (Billing) {
        Billing.ROOT = '', Billing.MY_INVOICES = 'invoices', Billing.MY_PAYMENTS = 'payment', Billing.PAYMENT_METHODS = 'payment-methods', Billing.PAYMENT_METHODS_ADD = 'add';
        function url(routes) {
            return '/' + Billing.ROOT + '/' + routes.join('/');
        }
        Billing.url = url;
    })(Billing = RouterMap.Billing || (RouterMap.Billing = {}));
    let Subscriptions;
    (function (Subscriptions) {
        Subscriptions.ROOT = 'subscriptions';
        function url(routes) {
            return '/' + Subscriptions.ROOT + '/' + routes.join('/');
        }
        Subscriptions.url = url;
    })(Subscriptions = RouterMap.Subscriptions || (RouterMap.Subscriptions = {}));
    let Brokerage;
    (function (Brokerage) {
        Brokerage.ROOT = '', Brokerage.ROSTER = 'roster', Brokerage.INVOICES = 'brokerage-invoices', Brokerage.OFFICE_PROFILE = 'office-profile', Brokerage.EDIT_OFFICE_PROFILE = 'office-profile/edit/:id', Brokerage.UNREPORTED_LICENSEES = 'unreported-licensees';
        function url(routes) {
            return '/' + Brokerage.ROOT + '/' + routes.join('/');
        }
        Brokerage.url = url;
    })(Brokerage = RouterMap.Brokerage || (RouterMap.Brokerage = {}));
    let Search;
    (function (Search) {
        Search.ROOT = '', Search.MEMBER_OFFICE = 'member-office', Search.MEMBER_OFFICE_ROSTER = 'member-office/:id/office-roster';
        function url(routes) {
            return '/' + Search.ROOT + '/' + routes.join('/');
        }
        Search.url = url;
    })(Search = RouterMap.Search || (RouterMap.Search = {}));
    let Analytics;
    (function (Analytics) {
        Analytics.ROOT = 'domus-analitycs';
        function url(routes) {
            return '/' + Analytics.ROOT + '/' + routes.join('/');
        }
        Analytics.url = url;
    })(Analytics = RouterMap.Analytics || (RouterMap.Analytics = {}));
    let Showcase;
    (function (Showcase) {
        Showcase.ROOT = 'showcase', Showcase.BADGES = 'badges', Showcase.BUTTONS = 'buttons', Showcase.CARDS = 'cards', Showcase.CHIPS = 'chips', Showcase.CREDIT_CARD_FORM = 'credit-card-form', Showcase.DATATABLE = 'datatable', Showcase.FORM_FIELDS = 'form-fields', Showcase.LISTS = 'lists', Showcase.LOADING_INDICATORS = 'loading-indicators', Showcase.MODALS = 'modals', Showcase.SNACKBARS = 'snackbars', Showcase.STEPPER = 'stepper', Showcase.TABS = 'tab-group', Showcase.LOGIN_USER_SELECTOR = 'login-user-selector', Showcase.TYPOGRAPHY = 'typography';
        function url(routes) {
            return '/' + Showcase.ROOT + '/' + routes.join('/');
        }
        Showcase.url = url;
    })(Showcase = RouterMap.Showcase || (RouterMap.Showcase = {}));
    let Login;
    (function (Login) {
        Login.ROOT = 'login', Login.CALLBACK = 'callback';
        function url(routes) {
            return '/' + Login.ROOT + '/' + routes.join('/');
        }
        Login.url = url;
    })(Login = RouterMap.Login || (RouterMap.Login = {}));
    let Payment;
    (function (Payment) {
        Payment.ROOT = 'payment', Payment.CALLBACK = 'callback';
        function url(routes) {
            return '/' + Payment.ROOT + '/' + routes.join('/');
        }
        Payment.url = url;
    })(Payment = RouterMap.Payment || (RouterMap.Payment = {}));
})(RouterMap || (RouterMap = {}));

function isJwtValid(token) {
    if (token) {
        const jwt = jwt_decode(token);
        const current = new Date().getTime() / 1000;
        return current <= jwt.exp;
    }
    else {
        return false;
    }
}
function userIdFromJwt(token) {
    if (token) {
        const jwt = jwt_decode(token);
        return jwt.session_data && jwt.session_data.user_id;
    }
    else {
        return null;
    }
}
function associationIdFromJwt(token) {
    if (token) {
        const jwt = jwt_decode(token);
        return jwt.session_data && jwt.session_data.tangilla_association_nrds_id;
    }
    else {
        return null;
    }
}

function setTimeToDate(time, date, timezone) {
    let currentTimeZoneHoursOffset = 0;
    if (timezone) {
        currentTimeZoneHoursOffset = getTimeZoneHoursOffsetFromUtc(timezone);
    }
    else {
        currentTimeZoneHoursOffset = new Date().getTimezoneOffset() / 60;
    }
    const timeValues = time.split(':');
    date.setHours(parseInt(timeValues[0], 10) + currentTimeZoneHoursOffset);
    date.setMinutes(parseInt(timeValues[1], 10));
    date.setSeconds(parseInt(timeValues[2], 10));
    return date;
}
function setTimeToMoment(time, momentValue) {
    const timeValues = time.split(':');
    if (momentValue) {
        momentValue.hours(parseInt(timeValues[0], 10));
        momentValue.minutes(parseInt(timeValues[1], 10));
        momentValue.seconds(parseInt(timeValues[2], 10));
        return momentValue;
    }
    return moment({
        hours: parseInt(timeValues[0], 10),
        minutes: parseInt(timeValues[1], 10),
        seconds: parseInt(timeValues[2], 10)
    });
}
function getTimeZoneHoursOffsetFromUtc(timezone) {
    const now = moment();
    if (timezone) {
        now.tz(timezone);
    }
    return now.utcOffset() / 60;
}
function dateToShortFormat(date) {
    const day = date.getUTCDate();
    const month = date.getUTCMonth() + 1;
    const year = date.getUTCFullYear();
    return `${year}-${('0' + (month)).slice(-2)}-${('0' + (day)).slice(-2)}`;
}
function getTodayAtFirstHour() {
    const date = new Date();
    date.setHours(0, 0, 0, 0);
    return date;
}
function dateToDateTimeFormat(stringDate) {
    const expiry = new Date();
    if (stringDate) {
        const separatedExpiryValues = stringDate.split('-');
        expiry.setFullYear(+separatedExpiryValues[0]);
        expiry.setUTCMonth(+separatedExpiryValues[1] - 1);
        expiry.setUTCDate(+separatedExpiryValues[2]);
    }
}

/**
 * Generated bundle index. Do not edit.
 */

export { BillingEntitiesUtilService, CustomModal, DeleteModal, FilesUtilsService, LayoutUtilService, LicensesUtilService, ReportingUtilsService, RouteUtilsService, RouterMap, SnackbarComponent, SnackbarModule, SnackbarService, associationIdFromJwt, dateToDateTimeFormat, dateToShortFormat, getTimeZoneHoursOffsetFromUtc, getTodayAtFirstHour, isJwtValid, setTimeToDate, setTimeToMoment, userIdFromJwt };
